import React, { memo, useMemo } from "react";

import { UseShowDescriptionWithMentions } from "utils";
import styles from "./styles.module.scss";

interface IFileDescriptionBox {
	description: string | null;
	tags: string[];
	mentions: string[];
}

const FileDescriptionBox: React.FunctionComponent<IFileDescriptionBox> = ({
	description,
	tags,
	mentions,
}) => {
	const parsedTags = useMemo(() => {
		if (tags.length === 0) {
			return [];
		} else {
			const newTags = tags.map((item: string) => {
				return {
					tagToFilter: item,
					showTag: `#${item.toLocaleLowerCase()}`,
				};
			});
			return newTags;
		}
	}, [tags]);

	return (
		<div className={styles.fileDescriptionWrapper}>
			{description && (
				<div className={styles.description}>
					<span className={styles.title}>{"Description"}:</span>
					<UseShowDescriptionWithMentions
						text={description || ""}
						mentions={mentions}
					/>
				</div>
			)}
			{parsedTags.length > 0 &&
				parsedTags.map((item: any, index: number) => {
					return (
						<small
							key={`tag_${index}_${item.showTag}`}
							className={styles.tag}
						>
							{item.showTag}
						</small>
					);
				})}
		</div>
	);
};

export default memo(FileDescriptionBox);
